import { UniversalConfig } from '@application/universal_config.service';
import { AspectRatio } from '@cellula/react';
import { useResolve } from '@visiba/instantiation';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(Link)`
	mask-image: -webkit-linear-gradient(30deg, rgb(0, 0, 0) 25%, rgba(0, 0, 0, 0.2) 50%, rgb(0, 0, 0) 75%);
	mask-size: 400%;
	-webkit-mask-position-x: 0px;
	-webkit-mask-position-y: center;

	&:hover {
		transition-duration: 0.4s, 0.8s;
		transition-timing-function: cubic-bezier(0.4, 0, 1, 1), cubic-bezier(0.4, 0, 1, 1);
		transition-delay: 0s, 0s;
		transition-property:
			mask-position,
			-webkit-mask-position;
		-webkit-mask-position-x: -150%;
		-webkit-mask-position-y: center;
	}
`;

interface Props {
	size?: 'small' | 'medium' | 'large';
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export function Logo({ size = 'medium', onClick }: Props) {
	const universalConfig = useResolve(UniversalConfig);

	let width: number;
	switch (size) {
		case 'small':
			width = 48;
			break;
		case 'medium':
			width = 96;
			break;
		case 'large':
			width = 128;
			break;
	}

	return (
		<StyledLink to='/' onClick={onClick}>
			<div
				style={{
					width: width,
				}}
			>
				<AspectRatio.Root ratio={2}>
					<AspectRatio.Img
						src={universalConfig.logo}
						alt=''
						style={{
							objectFit: 'contain',
							width: '100%',
							height: '100%',
							borderRadius: 'var(--radius-2)',
						}}
					/>
				</AspectRatio.Root>
			</div>
		</StyledLink>
	);
}
